import React from "react";
import Flx from "../layout/Flx";
import Txt from "../typography/Txt";

const EmptyStatePlaceholder = ({ icon, title, message, action }) => (
  <Flx column centerX centerY gap={1.5} sx={{ py: 6, px: 3, textAlign: "center" }}>
    {icon && <Flx>{icon}</Flx>}
    {title && (
      <Txt component="div" variant="h4">
        {title}
      </Txt>
    )}
    {message && (
      <Txt
        component="div"
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 480 }}
      >
        {message}
      </Txt>
    )}
    {action}
  </Flx>
);

export default EmptyStatePlaceholder;
